import React from "react";
import { CSSTransition } from "react-transition-group";
import { IconButton } from "../IconButton/IconButton";
import styles from "./Popin.module.scss";
import classNames from "classnames";
export function Popin(_a) {
    var _b, _c;
    var isOpen = _a.isOpen, children = _a.children, title = _a.title, onClose = _a.onClose, _d = _a.size, size = _d === void 0 ? "md" : _d, _e = _a.closeButton, closeButton = _e === void 0 ? true : _e, _f = _a.style, style = _f === void 0 ? "blue" : _f;
    var closeIcon = style === "blue"
        ? require("@/public_assets/button_close_white.png")
        : require("@/public_assets/button_close.png");
    return (React.createElement(CSSTransition, { in: isOpen, timeout: 300, classNames: styles, unmountOnExit: true, mountOnEnter: true },
        React.createElement("div", { className: styles.popinHolder },
            React.createElement("div", { className: classNames(styles.closeLayer, (_b = {},
                    _b[styles.transparent] = onClose == null,
                    _b)), onClick: onClose }),
            React.createElement("div", { className: classNames(styles.popin, (_c = {},
                    _c[styles.white] = style === "white",
                    _c[styles.large] = size === "lg",
                    _c)) },
                (onClose || title) && (React.createElement("div", { className: styles.header },
                    title && React.createElement("h2", { className: styles.title }, title),
                    onClose && closeButton && (React.createElement(IconButton, { className: styles.closeButton, onClick: onClose, icon: closeIcon, iconHover: closeIcon })))),
                children))));
}
